/**
 * Пользовательский валидатор data-parsley-dateIso для дат.
 * Регулярка взята из исходника parsley-1.1.18 (исключено в версии 2.x).
 */
window.Parsley.addValidator('dateiso', {
  requirementType: 'string',
  validateString: function (value) {
    return /^(\d{4})\D?(0[1-9]|1[0-2])\D?([12]\d|0[1-9]|3[01])$/.test(value)
  },
  messages: {
    en: 'Incorrect date format',
    ru: 'Некорректный формат даты'
  }
})

/**
 * Проверка для человеческого имени с инициалами. Только буквы, точки, пробел, дефис.
 */
window.Parsley.addValidator('username', {
  requirementType: 'string',
  validateString: function (value) {
    let valid

    if (value === 'R2D2') {
      alert('Piu piu!')
    }

    // Имя Фамилия
    valid = /^[a-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]{2,}(?:[\s\-][a-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]+){1,2}$/iu.test(value.trim())
    valid = valid && (!(value.match(/[.-]{2,}/g) || []).length) // две точки-тире

    return valid
  },
  priority: 33,
  messages: {
    en: 'Incorrect name format.',
    ru: 'Укажите имя и фамилию.'
  }
})

/**
 * Проверка для номера телефона
 */
window.Parsley.addValidator('phonenumber', {
  requirementType: 'string',
  validateString: function (value) {
    return /^(\+?\d{1,3}[-\s]?|)\(?\d{2,4}\)?(?:[-\s]?\d{2,5})+$/.test(value)
      && value.match(/\d+/g).join('').length > 8
  },
  messages: {
    en: 'Incorrect phone number format.',
    ru: 'Чего-то не хватает.<br>В номере допускаются только символы цифр, скобки, пробелы, знаки + и -.<br>Например: +7 777 123 1234'
  }
})

/**
 * Дата и время
 */
window.Parsley.addValidator('datetime', {
  requirementType: 'string',
  validateString: function (value) {
    return /20\d{2}\/[01]\d\/[0-3]\d\s([01]?[0-9]|2[0-3]):[0-5][0-9]/.test(value)
  },
  messages: {
    en: 'This value should be a valid datetime string.',
    ru: 'Поле должно содержать корректную дату и время.'
  }
})

/**
 * Поле адреса
 */
window.Parsley.addValidator('arrive_from', {
  requirementType: 'string',
  validateString: function (value) {
    return value && (
      // eslint-disable-next-line max-len
      /^[a-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]{3,}(?:[\s\-][a-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]+)*$/iu.test(value.trim())
    )
  },
  messages: {
    en: 'Incorrect name.',
    ru: 'Введите корректное название.'
  }
})

/**
 * Поле адреса в городе
 */
window.Parsley.addValidator('arrive_from_city', {
  requirementType: 'string',
  validateString: function (value) {
    return value && (
      // eslint-disable-next-line max-len
      /^[a-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]{3,}(?:[\s\-,\/\\.]+[\da-zа-яa-zа-я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u01C4-\u01CC\u0100-\u017F\u0492-\u04e9\u0400-\u04f0]+)*$/iu.test(value.trim())
    )
  },
  messages: {
    en: 'Use correct address, e.g.: Baker Street 221b',
    ru: 'Введите корректный адрес, например: <br/>Бейкер-стрит 221B'
  }
})

/**
 * Номер рейса/поезда
 */
window.Parsley.addValidator('trip_no', {
  requirementType: 'string',
  validateString: function (value) {
    return value && (
      // eslint-disable-next-line max-len
      /^[а-я\w\d]+(?:[\s\-_/\\]?[а-я\w\d\-\/\\]+)*$/i.test(value.trim())
    )
  },
  messages: {
    en: 'Use correct num, e.g.: IQ358, 041Ц, LH-648, 00/4Ц',
    ru: 'Введите корректный номер, например: <br/>IQ358, 041Ц, LH-648, 00/4Ц'
  }
})
